import React, { useRef } from 'react'
import LPFooterUIUX from './LPFooter/UIUX/LPFooter'
import LPFooterUIUXNav from './LPFooter/UIUX/LPFooterNav'
import LPFooterFrontend from './LPFooter/Frontend/LPFooter'
import LPFooterFrontendNav from './LPFooter/Frontend/LPFooterNav'
import LPFooterDesignSystem from './LPFooter/DesingSystem/LPFooter'
import LPFooterDesignSystemNav from './LPFooter/DesingSystem/LPFooterNav/LPFooterNav'
import LPFooterFlamingo from './LPFooter/Flamingo/LPFooter'
import { useRouter } from 'next/router'
import SiteMenu, { blankAttrs } from 'components/commons/HeaderFooter/SiteMenu'
import { hoverAttrs, useHoverEffect } from 'components/commons/HeaderFooter/useHoverEffect'
import { NavChild, NavItem, NavLink } from 'components/commons/HeaderFooter/types'

const logo = {
  href: '/',
  src: '/img/common/logo_aitria.svg',
  alt: 'Aitria',
}

// SNS・チームのリンクはすべて別タブ
const snsItems = [
  { href: 'https://x.com/aitria_jp', src: '/images/icons/icon_x.svg', alt: 'X' },
  { href: 'https://www.facebook.com/Aitria.jp', src: '/images/icons/icon_facebook.svg', alt: 'facebook' },
  { href: 'https://www.wantedly.com/companies/aitria', src: '/images/icons/icon_wantedly.svg', alt: 'Wantedly' },
]

const teamItems = [
  { href: 'https://tech.aitria.co.jp/', src: '/img/common/icon_engineer_team.svg', alt: 'エンジニアチーム' },
  { href: 'https://note.com/aitria_design', src: '/img/common/icon_designer_team.svg', alt: 'デザイナーチーム' },
]

const navItems: NavItem[] = [
  {
    title: 'Services',
    children: [
      {
        title: 'AIDD',
        links: [
          { href: '/services/aidd/', title: 'AI駆動開発TOP', isBlank: true },
          { href: '/services/aidd/internalization/', title: 'AI駆動開発内製化サービス', isBlank: true },
          { href: '/services/aidd/ai-agent-infrastructure/', title: 'AIエージェント基盤構築サービス', isBlank: true },
          { href: '/services/aidd/training/', title: 'AI駆動開発研修', isBlank: true },
        ],
      },
      {
        title: 'STUDIO',
        links: [
          { href: '/services/studio/ai-ux-sprint/', title: 'AI-UXスプリント', isBlank: true },
          { href: '/services/studio/ux-workshop/', title: 'UX/UIワークショップ', isBlank: true },
          { href: '/services/studio/application-development/', title: 'アプリケーション開発' },
          { href: '/services/studio/modernization/', title: 'モダナイゼーション' },
          { href: '/services/studio/uxui-improvement/', title: 'UX/UI改善' },
          { href: '/services/studio/design-system/', title: 'デザインシステム構築支援' },
        ],
      },
      {
        title: 'FORGE',
        links: [{ href: '/services/forge/cloudnative/', title: 'クラウドネイティブ' }],
      },
      {
        title: 'Products',
        links: [
          { href: 'https://phennec.ai/', title: 'Phennec', isBlank: true },
          { href: '/products/flamingo/', title: 'flamingo', isBlank: true },
          { href: '/products/zebra/', title: 'ZEBRA' },
          { href: 'https://eland.jp/', title: 'ELAND', isBlank: true },
        ],
      },
    ],
  },
  {
    href: '/cases/',
    title: 'Case study',
  },
  {
    href: '/about/',
    title: 'About',
    children: [
      {
        links: [{ href: '/mvv/', title: '当社が目指しているもの' }],
      },
    ],
  },
  {
    href: '/pressrelease/page/1/',
    title: 'Topics',
    children: [
      {
        links: [
          { href: '/pressrelease/page/1/', title: 'Press release' },
          { href: '/news/page/1/', title: 'News' },
          { href: '/events/page/1/', title: 'Event/Seminer' },
        ],
      },
    ],
  },
  {
    href: '/in-pocket/',
    title: 'Blog',
  },
  {
    href: 'https://aitria.careers/',
    title: 'Recruit',
    isBlank: true,
  },
  {
    href: '/contact/',
    title: 'Contact',
  },
  {
    href: '/download/',
    title: 'Download',
  },
  {
    href: '/mailmagazine/',
    title: 'Mail magazine',
  },
]

const technologyItems = [
  { src: '/images/icons/footer-gitlab.png', alt: 'GitLab Open Partner' },
  { src: '/img/common/aws_select_tier_services_partner.svg', alt: 'AWS Select Tier Services Partner' },
  { src: '/img/common/aws_amazon_ecs_delivery_partner.svg', alt: 'Amazon ECS Delivery Partner' },
]

const otherItems: NavLink[] = [{ href: '/security-privacy/', title: '情報セキュリティ方針・個人情報保護方針' }]

const copyright = '© Aitria Co., Ltd.'

const chunkByTwo = (children: NavChild[]): NavChild[][] =>
  children.reduce<NavChild[][]>((rows, child, i) => {
    if (i % 2 === 0) rows.push([child])
    else rows[rows.length - 1].push(child)
    return rows
  }, [])

const FooterNavItem: React.FC<{ item: NavItem }> = ({ item }) => {
  const isServices = item.title === 'Services'
  const children = item.children || []

  return (
    <div className={`prj-footer__nav--item ${isServices ? '--lg' : ''}`}>
      {isServices ? (
        <p className="--text prj-footer__nav--text font-upgrade">{item.title}</p>
      ) : (
        <a
          {...hoverAttrs(300, 600)}
          href={item.href}
          className="prj-footer__nav--link c-link__main"
          {...blankAttrs(item.isBlank, item.href)}
        >
          <p className="--text prj-footer__nav--text font-upgrade">{item.title}</p>
        </a>
      )}
      {children.length > 0 && (
        <div className="prj-footer__nav--children">
          {chunkByTwo(children).map((row, r) => (
            <ul className="prj-footer__nav--children--list" key={r}>
              {row.map((child, j) => (
                <li className="prj-footer__nav--children--item" key={child.title || j}>
                  {child.title && <p className="--text prj-footer__nav--children--title">{child.title}</p>}
                  <div className="prj-footer__nav--children--nav">
                    <ul className="prj-footer__nav--children--nav--list">
                      {child.links.map((link) => (
                        <li className="prj-footer__nav--children--nav--item" key={link.href}>
                          <a
                            {...hoverAttrs(400, 600)}
                            href={link.href}
                            className="prj-footer__nav--children--nav--link c-link__footer--inline"
                            {...blankAttrs(link.isBlank, link.href)}
                          >
                            <p className="--text prj-footer__nav--children--nav--text">{link.title}</p>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>
              ))}
            </ul>
          ))}
        </div>
      )}
    </div>
  )
}

const MainFooter: React.FC = () => {
  const footerRef = useRef<HTMLElement>(null)
  const [firstItem, ...restItems] = navItems

  useHoverEffect(footerRef)

  return (
    <footer ref={footerRef} className="prj-footer">
      <div className="c-container">
        <div className="prj-footer__inner">
          <div className="prj-footer__heading">
            <div className="prj-footer__logo">
              <a href={logo.href} className="prj-footer__logo--link no-icon">
                <img src={logo.src} alt={logo.alt} className="c-image__normal" />
              </a>
            </div>
            <div className="prj-footer__sns">
              <ul className="prj-footer__sns--list">
                {snsItems.map((sns) => (
                  <li className="prj-footer__sns--item" key={sns.href}>
                    <a
                      {...hoverAttrs(400, 600)}
                      href={sns.href}
                      className="prj-footer__sns--link c-link__sns no-icon"
                      {...blankAttrs(true, sns.href)}
                    >
                      <img src={sns.src} alt={sns.alt} className="--icon c-image__normal" />
                    </a>
                  </li>
                ))}
              </ul>
              <div className="prj-footer__sns--teams">
                <ul className="prj-footer__sns--teams--list">
                  {teamItems.map((team) => (
                    <li className="prj-footer__sns--teams--item" key={team.href}>
                      <a
                        {...hoverAttrs(400, 600)}
                        href={team.href}
                        className="prj-footer__sns--teams--link c-link__team no-icon"
                        {...blankAttrs(true, team.href)}
                      >
                        <img src={team.src} alt={team.alt} className="c-image__normal" />
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <span className="prj-footer__line" />
          <nav className="c-display__block--md prj-footer__nav">
            <div className="prj-footer__nav--list">
              <FooterNavItem item={firstItem} />
              <div className="prj-footer__nav--container">
                {restItems.map((item) => (
                  <FooterNavItem key={item.title} item={item} />
                ))}
              </div>
            </div>
          </nav>

          <div className="c-display__hidden--md prj-footer__nav">
            <SiteMenu items={navItems} isFooter />
          </div>
        </div>
        <div className="prj-footer__footer">
          <div className="prj-footer__footer--inner">
            <div className="prj-footer__footer--technology">
              <ul className="prj-footer__footer--technology--list">
                {technologyItems.map((tech) => (
                  <li className="prj-footer__footer--technology--item" key={tech.src}>
                    <img src={tech.src} alt={tech.alt} className="c-image__normal" />
                  </li>
                ))}
              </ul>
            </div>
            <div className="prj-footer__footer--copyright">
              <nav className="prj-footer__footer--copyright--nav">
                <ul className="prj-footer__footer--copyright--nav--list">
                  {otherItems.map((other, i) => (
                    <li
                      className={`prj-footer__footer--copyright--nav--item ${i === otherItems.length - 1 ? '--last' : ''}`}
                      key={other.href}
                    >
                      <a
                        {...hoverAttrs(300, 600)}
                        href={other.href}
                        className="prj-footer__footer--copyright--nav--link c-link__main--sub"
                      >
                        <p className="--text prj-footer__footer--copyright--nav--text">{other.title}</p>
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
              <p className="prj-footer__footer--copyright--text font-upgrade">{copyright}</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

const Footer: React.FC = () => {
  const router = useRouter()
  const isDesignSystemLpPage: boolean = new RegExp(/services\/designsystem|lp-designsystem-completed/).test(
    router.pathname,
  )
  const isUIUXLpPage: boolean = new RegExp(/uiuxdesign-lp2|\/lp-ui-contact-completed/).test(router.pathname)
  const isFrontendBackendLpPage: boolean = new RegExp(
    /\/services\/frontend-dev|\/lp-frontend-contact-completed|\/backend-dev|\/lp-backend-contact-completed/,
  ).test(router.pathname)
  const isContactPage: boolean = new RegExp(/\/contact\/?$/).test(router.pathname)
  const isAgreementPage: boolean = new RegExp(/\/agreement/).test(router.pathname)
  const isFlamingoPage: boolean = router.pathname.includes('/products/flamingo')

  if (isDesignSystemLpPage) {
    return (
      <footer>
        <LPFooterDesignSystemNav />
        <LPFooterDesignSystem />
      </footer>
    )
  }
  if (isUIUXLpPage) {
    return (
      <footer>
        <LPFooterUIUXNav />
        <LPFooterUIUX />
      </footer>
    )
  }
  if (isFrontendBackendLpPage) {
    return (
      <footer>
        <LPFooterFrontendNav />
        <LPFooterFrontend />
      </footer>
    )
  }
  if (isFlamingoPage) {
    return (
      <>
        <LPFooterFlamingo />
        <MainFooter />
      </>
    )
  }

  if (isAgreementPage || isContactPage) return <></>
  return <MainFooter />
}

export default Footer
